import { useEffect, useState } from "react";
import { TwitchEmbed } from "react-twitch-embed";
import { SiTwitch } from "react-icons/si";
import { BRAND } from "@/lib/brand";

export default function LiveTwitch() {
  const [host, setHost] = useState("");
  useEffect(() => {
    setHost(window.location.hostname);
  }, []);

  return (
    <section
      id="live"
      data-testid="live-twitch-section"
      className="relative py-24 lg:py-32 bg-[#050505] overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(212,175,55,0.1)_0%,transparent_60%)]" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-4">
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37]">
              ⌁ Live Now
            </p>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl font-black uppercase tracking-tight text-white">
              Inside The <span className="gold-text">Arena</span>
            </h2>
            <p className="mt-5 text-zinc-400">
              Watch our captains stream scrims, breakdowns, and tournament runs
              direct from the TGL HQ. Pull up a chair — or pull up a chat.
            </p>
            <div className="mt-8 flex items-center gap-4">
              <a
                href={`https://twitch.tv/${BRAND.twitchChannel}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="twitch-channel-link"
                className="inline-flex items-center gap-2 border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10 font-bold uppercase tracking-widest text-xs px-5 py-3 cut-corners transition-colors"
              >
                <SiTwitch size={14} /> @{BRAND.twitchChannel}
              </a>
              <span className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-zinc-400">
                <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
                Channel
              </span>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-4">
              {[
                { k: "8 PM ET", v: "Daily Stream" },
                { k: "Sunday", v: "Watch Party" },
              ].map((s) => (
                <div
                  key={s.v}
                  className="border border-white/10 p-4 cut-corners bg-black/40"
                >
                  <div className="font-display text-lg font-bold text-white">
                    {s.k}
                  </div>
                  <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-400 mt-1">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div
            className="lg:col-span-8 cut-corners overflow-hidden border border-[#D4AF37]/30 bg-black"
            data-testid="twitch-embed-wrapper"
          >
            <div className="aspect-video w-full">
              {host && (
                <TwitchEmbed
                  channel={BRAND.twitchChannel}
                  parent={[host]}
                  withChat={false}
                  muted={true}
                  width="100%"
                  height="100%"
                  darkMode={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
